import React, { useState, useEffect, useContext } from "react";
import "./Order_Cancle.css";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Successfull_Modal from "../../../Common_modal/Successfull_Modal/Successfull_Modal";
import Cancle_Reason_Modal from "../../../Common_modal/Cancle_Reason_Modal/Cancle_Reason_Modal";
import Common_Button from "../../../Common-Component/Common_Button/Common_Button";
import {
  singleOrderGet,
  OrderCancel,
} from "../../../../utils/apis/myAccount/myAccount";
import { Context } from "../../../../utils/context";
import { useNavigate } from "react-router-dom";

function Order_Cancle({ orderId, onHide }) {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [modalCanleReasonShow, setModalCanleReasonShow] = useState(false);

  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const hideModalWithDelay = () => {
    setTimeout(() => {
      window.location.href = "/my-account";
      setModalShow(false);
    }, 3000);
  };

  const handleSubmit = async () => {
    const data = {
      order_id: orderId,
    };
    if (reason) {
      data.reason = reason;
    }
    if (remark) {
      data.remark = remark;
    }
    const res = await OrderCancel(data);
    if (res?.success) {
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
        onHide();
        window.location.reload();
        // navigate("/");
      }, 3000);
    } else {
      setErrorMessage(res?.message?.errors?.reason?.msg);
    }
  };

  const [order, setOrder] = useState([]);
  const getOrder = async () => {
    const res = await singleOrderGet(orderId);
    if (res?.success) {
      setOrder(res?.data);
    }
  };
  const { IMG_URL } = useContext(Context);
  useEffect(() => {
    getOrder();
  }, []);

  return (
    <>
      <div className="Order_Cancle my-account">
        <div className="container-fluid">
          <div className="product-section-div">
            <div className="product-div">
              <div className="row">
                {order?.orders_details?.map((items) => (
                  <div
                    className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-3 col-4"
                    key={items.product_id}
                  >
                    {items?.product?.product_images?.map((image) => (
                      <div className="product" key={image.id}>
                        <img
                          className="img-set"
                          src={IMG_URL + image?.image}
                          alt=""
                        />
                      </div>
                    ))}
                  </div>
                ))}
                {/* <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-3 col-4">
                  <div className="product">
                    <img
                      className="img-set"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/My_Profile/tomato.png"
                      }
                      alt=""
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <div className="text-holder">
              <p>Order ID {order?.invoice_number}</p>
              <h4>
                {order?.orders_details?.map((value) => {
                  return <div key={value.id}>{value?.product?.name}</div>;
                })}
                {order?.product?.unit} Pc
              </h4>
              {/* <span>(Approx. 600 -1000 gm)</span> */}
              <h4>
                amount -{" "}
                {/* {Number(order?.price ?? 0) +
                  (Number(order?.price ?? 0) *
                    Number(order?.tax_percent ?? 0)) /
                    100} */}
                {order?.amount}
              </h4>
            </div>
          </div>

          <div
            className="Cancellation"
            onClick={() => setModalCanleReasonShow(true)}
          >
            <p>
              Select a reason for cancellation{" "}
              <FontAwesomeIcon
                className="ms-2"
                icon="fa-solid fa-angle-right"
              />
              <span style={{ color: "red" }}>{errorMessage}</span>
            </p>
          </div>

          <div className="Cancellation  Cancellation-reason">
            <p>
              Could you tell us a reason for cancellation?{" "}
              <span>(optional)</span>
            </p>
            <Form>
              <Form.Control
                as="textarea"
                role="1"
                placeholder="Type a reason"
                onChange={(e) => setRemark(e.target.value)}
              />
            </Form>

            {reason && (
              <p>
                Your Reason:
                <span> {reason}</span>
              </p>
            )}

            <div className="btn-holder">
              {/* <Link to={"/"}> */}
              <Common_Button
                text="Cancel"
                className="cancel-btn"
                onClick={onHide}
              />
              {/* </Link> */}

              <Common_Button
                // onClick={() => { setModalShow(true); hideModalWithDelay() }}
                onClick={handleSubmit}
                text="Submit"
                className="submit-btn"
              />
            </div>
          </div>
        </div>
      </div>

      <Successfull_Modal
        message=" Your order has been canceled successfully "
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Cancle_Reason_Modal
        reason={reason}
        setErrorMessage={setErrorMessage}
        setReason={setReason}
        show={modalCanleReasonShow}
        onHide={() => setModalCanleReasonShow(false)}
        text={"cancellation"}
      />
    </>
  );
}

export default Order_Cancle;
